import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Credentials } from '@/store/auth/types';
import { onMounted, ref } from 'vue';


export default _defineComponent({
  expose: [],
  props: {
    adminUrls: { type: Array, required: true },
    timeoutMs: { type: Number, required: true }
  } as unknown as undefined,
  emits: ["credentialsFound", "noCredentialsFound"] as unknown as undefined,
  setup(__props: {
    adminUrls: string[];
    timeoutMs: number;
  }, { emit }: {
        emit: ({
    (e: 'credentialsFound', credentials: Credentials): void;
    (e: 'noCredentialsFound'): void;
  }),
        slots: any,
        attrs: any
      }) {

const { adminUrls, timeoutMs } = __props




const iframeWrapper = ref<HTMLIFrameElement | null>(null);

const isCredentials = (maybeCreds: any): maybeCreds is Credentials =>
  !!maybeCreds && !!maybeCreds['access-token'] && maybeCreds.client && maybeCreds.uid;

const checkAdminUrl = (adminUrl: string): Promise<Credentials | 'none'> => {
  const iframe = document.createElement('iframe');
  iframe.src = `${adminUrl}/auth/browser-extension-provider`;
  iframe.className = 'credentials-iframe';

  const credentialsPromise = new Promise<Credentials | 'none'>((resolve) => {
    const listener = (messageEvent: MessageEvent<any>): void => {
      if (messageEvent.origin !== adminUrl) {
        return;
      }

      removeEventListener('message', listener);
      iframe.remove();
      resolve(isCredentials(messageEvent.data) ? messageEvent.data : 'none');
    };

    addEventListener('message', listener);
    setTimeout(() => {
      removeEventListener('message', listener);
      iframe.remove();
      resolve('none');
    }, timeoutMs);
    iframeWrapper.value?.appendChild(iframe);
  });

  return credentialsPromise;
};

onMounted(async () => {
  for (const adminUrl of adminUrls) {
    const credsOrNone = await checkAdminUrl(adminUrl);

    if (credsOrNone !== 'none') {
      emit('credentialsFound', credsOrNone);
      return;
    }
  }

  emit('noCredentialsFound');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock("div", {
    ref: iframeWrapper,
    class: "credentials-iframe-wrapper"
  }, null, 512))
}
}

})